import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import authReducer from './slices/authSlice';
import appointmentReducer from './slices/appointmentSlice';

const appReducer = combineReducers({
  auth: authReducer,
  appointment: appointmentReducer,
});

const persistConfig = {
  key: 'tcs_root',
  storage: storageSession,
  whitelist: ['auth', 'appointment'],
};

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer as any);

export type RootState = ReturnType<typeof appReducer>;

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;

// Typed accessor for `store.getState()`. The persisted state is a superset of
// RootState (it adds redux-persist's `_persist` field), so consumers reading
// app state should go through this helper rather than double-casting at every
// call site.
export const getAppState = (): RootState => store.getState() as unknown as RootState;




